// extracted by mini-css-extract-plugin
export var dropdownContainer = "_n5-0";
export var leftAlign = "_n5-4";
export var listItem = "_n5-2";
export var listItemWrapper = "_n5-1";
export var operationText = "_n5-3";